import { render, staticRenderFns } from "./BlockRepeater.vue?vue&type=template&id=4fc0e742"
import script from "./BlockRepeater.vue?vue&type=script&lang=js"
export * from "./BlockRepeater.vue?vue&type=script&lang=js"
import style0 from "./BlockRepeater.vue?vue&type=style&index=0&id=4fc0e742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports